import React from "react";
import Link from "gatsby-link";

const NavigationLink = ({ pageMetadata, isActive, isInternal = true }) => (
  <div style={isActive ? { color: "black", textDecoration: "underline" } : {}}>
    {isInternal ? (
      <Link to={pageMetadata.path} href={pageMetadata.path}>
        {pageMetadata.displayTitle.toUpperCase()}
      </Link>
    ) : (
      <a href={pageMetadata.path} rel="noopener" target="_blank">
        {pageMetadata.displayTitle.toUpperCase()}
      </a>
    )}
  </div>
);

export default NavigationLink;



// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationLink.jsx